import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { companyActions } from "../../../../../../actions";
import TextField from "@mui/material/TextField";
import moment from "moment";
import validateIncorporationDate from "./validateIncorporationDate";

const UEN = ({ setShowPopupD, setShowPopupE, onIncorporationDateValidationChange }) => {
  const dispatch = useDispatch();

  const company = useSelector(state => state.company.details);
  const quoteId = useSelector(state => state.quote.id);
  const quoteLocked = useSelector(state => state.quote?.locked);
  const validationRequest = useRef(0);
  const [validationError, setValidationError] = useState("");

  useEffect(() => () => {
    validationRequest.current += 1;
  }, [quoteId, company.uen_no, company.incorporation_date]);

  const handleBlur = () => {
    const dateValue = company.incorporation_date;
    if (quoteLocked || !company.uen_no || !/^[a-zA-Z0-9]+$/.test(company.uen_no) ||
      dateValue == null || `${dateValue}`.trim() === "") {
      return;
    }

    const date = moment(Number.isFinite(Number(dateValue)) ? Number(dateValue) : dateValue);
    if (!date.isValid()) {
      return;
    }

    const requestId = ++validationRequest.current;
    return validateIncorporationDate({
      quoteId,
      uen: company.uen_no,
      incorporationDate: date.format("YYYY-MM-DD"),
      setShowPopupD,
      setShowPopupE,
      onIncorporationDateValidationChange,
      setValidationError,
      isCurrent: () => requestId === validationRequest.current
    });
  };

  const [isError, setIsError] = useState({ error: false, message: "" });

  useEffect(() => {
    // Check if uen_no is undefined or empty or contains only spaces
    const isUenNoEmpty = company.uen_no === undefined || !company.uen_no.trim();

    // Memoize the regex object for alphanumeric validation
    const regex = /^[a-zA-Z0-9]+$/;

    if (isUenNoEmpty) {
      setIsError(prevState => ({
        ...prevState,
        error: true,
        message: "Required"
      }));
    } else if (!regex.test(company.uen_no)) {
      setIsError(prevState => ({
        ...prevState,
        error: true,
        message: "Invalid characters"
      }));
    } else {
      setIsError(prevState => ({
        ...prevState,
        error: false,
        message: ""
      }));
    }
  }, [company]);

  return (
    <div>
      <TextField
        id="uen_no"
        name="uen_no"
        label="Enter the company Unique Entity Number"
        fullWidth
        value={company.uen_no}
        autoComplete="[off]"
        size="small"
        disabled={quoteLocked}
        inputProps={{
          maxLength: 15
        }}
        error={isError.error || Boolean(validationError)}
        helperText={isError.error ? isError.message : validationError}
        onBlur={handleBlur}
        onChange={event => {
          validationRequest.current += 1;
          setValidationError("");
          onIncorporationDateValidationChange?.(false);
          const fieldConfig = { key: "uen_no", value: event.target.value?.trim() };
          dispatch(companyActions.setCompanyFormDetails(fieldConfig));
        }}
      />
    </div>
  );
};

export default UEN;
